import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DownloadInvoices } from '../../../../models/invoices-reports.model';

@Component({
  selector: 'app-state-government',
  templateUrl: './state-government.component.html',
  styleUrls: ['./state-government.component.css']
})
export class InvoicesStateGovernmentComponent implements OnInit, OnDestroy {
  stateinvoicesreportform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  downloadInvoices: DownloadInvoices = new DownloadInvoices();
  accountOffices = [];
  fileType = [
    { value: '.pdf', viewValue: 'PDF File' },
    { value: '.xls', viewValue: 'Excel File' }
  ];

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.stateinvoicesreportform = new FormGroup({
      invDate: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      airAsiaRef: new FormControl({ value: '', disabled: false }),
      accountOffice: new FormControl({ value: '', disabled: false }),
      bookingDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      bookingDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      eportedFileType: new FormControl({ value: '', disabled: false }),
      invoiceNo: new FormControl({ value: '', disabled: false })
    });

    this.loading = true;

    let initial_sub = this.reportService.getInitNgrInvoices()
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.accountOffices = data.body['accountOffices'];

            this.stateinvoicesreportform.setValue({
              invDate: this.stateinvoicesreportform.get('invDate')!.value,
              airAsiaRef: this.stateinvoicesreportform.get('airAsiaRef')!.value,
              accountOffice: this.stateinvoicesreportform.get('accountOffice')!.value,
              bookingDateFrom: this.stateinvoicesreportform.get('bookingDateFrom')!.value,
              bookingDateTo: this.stateinvoicesreportform.get('bookingDateTo')!.value,
              eportedFileType: this.fileType[0].value,
              invoiceNo: this.stateinvoicesreportform.get('invoiceNo')!.value
            });
          } else {
            this.openSnackBar('Error loading agency and account office.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(initial_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    this.downloadInvoices.AirAsiaRef = this.stateinvoicesreportform.get('airAsiaRef')!.value;
    this.downloadInvoices.AccountOfficeCode = this.stateinvoicesreportform.get('accountOffice')!.value;
    this.downloadInvoices.BookingDateFrom = this.stateinvoicesreportform.get('bookingDateFrom')!.value;
    this.downloadInvoices.BookingDateTo = this.stateinvoicesreportform.get('bookingDateTo')!.value;
    this.downloadInvoices.InvoiceDate = this.stateinvoicesreportform.get('invDate')!.value;
    this.downloadInvoices.ExportFileType = this.stateinvoicesreportform.get('eportedFileType')!.value;
    this.downloadInvoices.InvoiceNumber = this.stateinvoicesreportform.get('invoiceNo').value;

    let update_sub = this.reportService.downloadNgrInvoices(this.downloadInvoices)
      .subscribe(
        (value) => {
          if (value.status === 204) {

          } else if (value.status === 200) {
            if (this.downloadInvoices.ExportFileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'NGR Invoice.xls');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            } else if (this.downloadInvoices.ExportFileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'NGR Invoice.pdf');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Error downloading invoice.', '');
          }
        },
        (error) => {
          this.isSubmit = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(update_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
